export enum Path {
    ROOT = '',
}
